import { useIsAudioNotePaused, useIsAudioNoteReconnecting } from '@renderer/hooks/audio/use-audio-note-selectors'

/**
 * Shared by the live-recording waveform and every elapsed timer beside it, so
 * they can't drift apart: the success green while capturing, the Mini logo's muted
 * foreground while paused or reconnecting.
 */
export const AUDIO_INDICATOR_COLOR = {
  live: 'text-success-subtle',
  paused: 'text-foreground-secondary',
} as const

export type AudioIndicatorTone = keyof typeof AUDIO_INDICATOR_COLOR

export function useAudioIndicatorTone(): AudioIndicatorTone {
  const isPaused = useIsAudioNotePaused()
  const isReconnecting = useIsAudioNoteReconnecting()
  return isPaused || isReconnecting ? 'paused' : 'live'
}
